module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("Twój profil")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary",
      "type": "flat"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.change-password'
        })
      }
    }
  }, [_vm._v("Zmień hasło")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "color": "primary",
      "type": "flat"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'logout'
        })
      }
    }
  }, [_vm._v("Wyloguj się")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tr', [_c('th', {
    staticClass: "short"
  }, [_vm._v("\n        Imię i nazwisko\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n        " + _vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n        E-mail\n      ")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": _vm.href(_vm.user.email)
    }
  }, [_vm._v(_vm._s(_vm.user.email))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28e62de3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/my/My.vue
// module id = 236
// module chunks = 0